import { pgTable, uuid, text, timestamp, boolean, index } from "drizzle-orm/pg-core";

export const telegramBotCredentials = pgTable("telegram_bot_credentials", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull(),
  mode: text("mode").notNull(),  // bot, business, gateway, channel
  encryptedBotToken: text("encrypted_bot_token").notNull(),
  // TODO: Wire encryption via @ease/crypto before storing — value must be encrypted at rest
  encryptedWebhookSecret: text("encrypted_webhook_secret"),
  webhookRegisteredAt: timestamp("webhook_registered_at", { withTimezone: true }),
  channelId: text("channel_id"),  // for channel mode
  phoneNumberId: text("phone_number_id"),  // for gateway mode
  isActive: boolean("is_active").default(true).notNull(),
  createdAt: timestamp("created_at", { withTimezone: true }).defaultNow().notNull(),
  updatedAt: timestamp("updated_at", { withTimezone: true }).defaultNow().notNull(),
}, (table) => [
  index("idx_telegram_creds_tenant").on(table.tenantId),
  index("idx_telegram_creds_mode").on(table.tenantId, table.mode),
]);
